export enum SunmiDeviceModel {
  T2s = 'T2s',
  T3 = 'T3',
  V2sPlus = 'V2sPlus',
  V2s = 'V2s',
  V3mix = 'V3_MIX_STD',
  D3Mini = 'D3MINI',
  Unknown = 'Unknown',
}

export enum SunmiPrinterWidth {
  w40mm,
  w58mm,
  w80mm,
}
